export default __webpack_public_path__ + "static/media/salRosada.31c30d40.jpeg";